document.addEventListener('DOMContentLoaded', function () {
    const buildingImageSelector = '.building-thumbnail-container img[data-fallback-src]';
    const replaceFailedBuildingImage = (image) => {
        const fallbackSrc = image.dataset.fallbackSrc;
        if (!fallbackSrc || image.dataset.fallbackApplied === 'true') {
            return;
        }

        image.dataset.fallbackApplied = 'true';
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src = fallbackSrc;
    };

    document.addEventListener(
        'error',
        (event) => {
            if (event.target.matches?.(buildingImageSelector)) {
                replaceFailedBuildingImage(event.target);
            }
        },
        true
    );

    document.querySelectorAll(buildingImageSelector).forEach((image) => {
        if (image.complete && image.naturalWidth === 0) {
            replaceFailedBuildingImage(image);
        }
    });

    // Initialize Bootstrap components
    const accordionElements = document.querySelectorAll('.accordion');
    if (typeof window.bootstrap !== 'undefined' && window.bootstrap.Collapse && accordionElements.length > 0) {
        accordionElements.forEach((element) => {
            new window.bootstrap.Collapse(element, {
                toggle: false,
            });
        });
    }

    // Note: Most filtering and sorting logic has been moved to server-side HTMX.
    // This file now primarily handles Bootstrap component initialization
    // and any residual client-side UI enhancements.
});
